import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIgStoryGrad = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 23.75 23.805",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "a",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#0142e4"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .508,
					stopColor: "#ea26a4"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fdc94f",
					stopOpacity: .794
				})
			]
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "b",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015,
			gradientUnits: "userSpaceOnUse"
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "d",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "c",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "f",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "e",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "h",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "g",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "j",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "i",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "l",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "k",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			xlinkHref: "#a",
			id: "m",
			gradientUnits: "userSpaceOnUse",
			x1: 4.99,
			y1: 50.015,
			x2: 94.754,
			y2: 50.015
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		transform: "matrix(.26458 0 0 .26458 -1.32 -1.33)",
		fill: "url(#b)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M49.77 95a45.086 45.086 0 01-21.16-5.277 3.104 3.104 0 112.925-5.477 38.843 38.843 0 0018.235 4.546 39 39 0 008.846-1.013 3.104 3.104 0 111.411 6.047A45.27 45.27 0 0149.77 95z",
				fill: "url(#d)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20.971 83.527a3.09 3.09 0 01-2.134-.851C12.514 76.687 8.093 69.072 6.051 60.655a3.105 3.105 0 116.035-1.463c1.758 7.251 5.57 13.813 11.021 18.977a3.104 3.104 0 01-2.136 5.358z",
				fill: "url(#f)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.098 48.949a3.104 3.104 0 01-3.093-3.41A44.664 44.664 0 018.967 31.05a3.105 3.105 0 015.629 2.621 38.443 38.443 0 00-3.412 12.479 3.105 3.105 0 01-3.086 2.799z",
				fill: "url(#h)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.121 22.656a3.104 3.104 0 01-2.397-5.074c.277-.338.558-.671.845-1a3.103 3.103 0 014.38-.301 3.103 3.103 0 01.301 4.38c-.247.283-.489.571-.728.861a3.1 3.1 0 01-2.401 1.134z",
				fill: "url(#j)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M71.254 89.079a3.105 3.105 0 01-1.598-5.768c11.651-6.976 18.889-19.734 18.889-33.295 0-21.381-17.395-38.776-38.776-38.776a3.105 3.105 0 110-6.21c24.805 0 44.985 20.18 44.985 44.985 0 15.733-8.395 30.532-21.909 38.622-.499.3-1.048.442-1.591.442z",
				fill: "url(#l)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "url(#m)",
				d: "M28.97 47.072v6.209h17.787v17.787h6.209V53.281h17.787v-6.209H52.966V29.285h-6.209v17.787z"
			})
		]
	})]
});
export default SvgIgStoryGrad;
